export enum SubscriptionStatus {
    ACTIVE = <any>'ACTIVE',
    EXPIRED = <any>'EXPIRED',
    CANCELLED = <any>'CANCELLED'
}
